/*
 * @Descripttion:cmx
 * @Author: lks
 * @Date: 2021-09-24 10:32:00
 * @LastEditors: lks
 * @LastEditTime: 2021-09-24 10:34:40
 */
import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';

const togetherRoute: RouteConfig[] = [
  // {
  //   path: '/together',
  //   component: PView,
  //   redirect: '/together/index.html',
  //   children: [
  //     {
  //       path: 'index.html',
  //       name: 'togetherIndex',
  //       component: () => import('@/views/otherHome/index.vue'),
  //       meta: { title: '弈起聚首页', parentTab: 'together' },
  //     },
  //   ],
  // },
];

export { togetherRoute };
